import React from "react";

import {component_tool} from "../../tool";

let {WizModal} = component_tool

let componentName = 'permissionSetting';

let bizTypeEnum = {
    0: '课程',
    1: '考试',
    2: '问卷',
    8: '培训主题(原线下课程)',
    12: '路径-必修',
    15: '报名',
    21: '证书',
    26: '直播',
    30: '作业',
    36: '班级',
    38: '任务',
    39: '路径',
  },
  permTypeEnum = {
    0: '管理',
    1: '学员',
  },
  typeEnum = {
    0: '合并',
    1: '替换',
  }


const columns = (self) => {
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "业务类型",
      name: "bizType",
      dataIndex: "bizType",
      dict: Object.keys(bizTypeEnum).map(key => ({code: parseInt(key), codeName: bizTypeEnum[key]})),
      searchItem: {
        type: 'select',
      },
      tableItem: {},
    },
    {
      title: "行为类型",
      name: "type",
      dataIndex: "type",
      dict: Object.keys(typeEnum).map(key => ({code: parseInt(key), codeName: typeEnum[key]})),
      searchItem: {
        type: 'select',
      },
      tableItem: {},
    },
    {
      title: "操作权限类型",
      name: "permType",
      dataIndex: "permType",
      dict: Object.keys(permTypeEnum).map(key => ({code: parseInt(key), codeName: permTypeEnum[key]})),
      searchItem: {
        type: 'select',
      },
      tableItem: {},
    },
    {
      title: "备注",
      name: "remark",
      dataIndex: "remark",
      searchItem: {},
      tableItem: {},
    },
    {
      title: "自动设置人员范围",
      name: "authInfo",
      dataIndex: "authInfo",
      tableItem: {
        render: (text, record) => {
          if (!text) {
            return null;
          }
          let {isAll, orgIds, positionIds, positionCategoryIds, personIds} = text
          if (isAll === 1) {
            return '全体人员'
          } else {
            let str = []
            if (orgIds?.length && orgIds.map(item => item?.name).length)
              str.push(<div>{'组织: ' + orgIds.map(item => item?.name).join(',')}</div>)
            if (positionCategoryIds?.length && positionCategoryIds.map(item => item?.name).filter(item => !!item).length)
              str.push(<div>{'岗位分类: ' + positionCategoryIds.map(item => item?.name).filter(item => !!item).join(',')}</div>)
            if (positionIds?.length && positionIds.map(item => item?.name).filter(item => !!item).length)
              str.push(<div>{'岗位: ' + positionIds.map(item => item?.name).filter(item => !!item).join(',')}</div>)
            if (personIds?.length && personIds.map(item => item?.userName).filter(item => !!item).length)
              str.push(<div>{'人员: ' + personIds.filter(item => !!item.userName).map(item => `${item?.fullName}(${item?.userName})`).join(',')}</div>)
            return str || '暂无';
          }
        }
      },
    },
    {
      title: "赋予范围",
      name: "targetAuthInfo",
      dataIndex: "targetAuthInfo",
      tableItem: {
        render: (text, record) => {
          if (!text) {
            return null;
          }
          let {isAll, orgIds, positionIds, positionCategoryIds, personIds} = text
          if (isAll === 1) {
            return '全体人员'
          } else {
            let str = []
            if (orgIds?.length && orgIds.map(item => item?.name).length)
              str.push(<div>{'组织: ' + orgIds.map(item => item?.name).join(',')}</div>)
            if (positionCategoryIds?.length && positionCategoryIds.map(item => item?.name).filter(item => !!item).length)
              str.push(<div>{'岗位分类: ' + positionCategoryIds.map(item => item?.name).filter(item => !!item).join(',')}</div>)
            if (positionIds?.length && positionIds.map(item => item?.name).filter(item => !!item).length)
              str.push(<div>{'岗位: ' + positionIds.map(item => item?.name).filter(item => !!item).join(',')}</div>)
            if (personIds?.length && personIds.map(item => item?.userName).filter(item => !!item).length)
              str.push(<div>{'人员: ' + personIds.filter(item => !!item.userName).map(item => `${item?.fullName}(${item?.userName})`).join(',')}</div>)
            return str || '暂无';
          }
        }
      },
    },
    {
      title: "是否有效",
      name: "state",
      dataIndex: "state",
      dict: [
        {code: 0, codeName: '无效'},
        {code: 1, codeName: '有效'},
      ],
      searchItem: {
        type: 'select',
      },
      tableItem: {
        width: 80,
      },
    },
  ]
}

const templateConfig = (self) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(self),
        searchBarProps: {
          collapse: false,
          cols: {
            xs: 24,
            md: 12,
            xl: 8
          },
          dataFormat: (params) => {
            let value = Object.assign({}, params)
            self.setState(value)
            return value;
          },
          buttonSort: [],
          buttons: []
        },
        modalFormProps: {},
        dataTableProps: {
          // rowKey: (record) => (record.bizType + '-' + record.id),
          rowKey: 'id',
          selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false,
        },
        rowOperateSort: ['update'],
        rowOperateProps: {
          width: 100,
        },
        rowOperateView: [
          {
            key: "update",
            custom: true,
            params: {children: "编辑"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/permissionSetting/save"
              }
            }
          }
        ],
        commonOperate: {},
      }
    }
  };
}

const apis = () => {
  return {
    list: {
      path: `${componentName}/pageList`,
      payload: {
        key: `${componentName}@list`,
        apiParams: {}
      }
    }
  }
}

let reduxTemplateConfig = (args) => {
  return {
    apis: apis(),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams: true,
    needLoading: true,
    ...args
  }
};

export {bizTypeEnum, permTypeEnum, typeEnum, reduxTemplateConfig, templateConfig};
